export default __webpack_public_path__ + "static/media/octadmin.d2a47ff8.jpg";